import { useState } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import useToggle from '@hook/useToggle'
import Modal from '@ui/component/Modal'
import CallPhotosSlider from '@scene/window/sterilization/__partials/CallPhotosSlider'

const useCallPhotosModal = () => {
  const [t] = useTranslation('sterilization')
  const [isModalActive, toggleModal] = useToggle(false)
  const [modalCall, setModalCall] = useState({ id: null, photos: [], address: null })

  const showPhotosModal = (callId, photos, activeScanState = null, address = null) => {
    const scanStateProp = {
      'is-second-scanned': 'isSecondScanned',
      'is-first-scanned': 'isFirstScanned',
      'is-visited': 'isVisited'
    }

    photos = Object.values(photos ?? {})
    if (activeScanState) {
      photos = photos.filter(photo => 1 === photo[scanStateProp[activeScanState]])
    }

    setModalCall({ id: callId, photos, address })
    toggleModal()
  }

  const photosModal = createPortal(
    <Modal cssClass='call-photos-modal' isActive={isModalActive} closeCallback={toggleModal} closeAction={true}>
      <h3>{t('titles.scan_photos_modal')}</h3>
      {isModalActive && <CallPhotosSlider callId={modalCall.id} photos={modalCall.photos} address={modalCall.address} />}
    </Modal>,
    document.body
  )

  return [showPhotosModal, photosModal]
}

export default useCallPhotosModal
